import * as Sentry from '@sentry/react'
import ErrorMessage from '@/components/ErrorMessage'
import styles from './index.module.sass'

const Error = () => {
  return (
    <div className={styles.content}>
      <ErrorMessage/>
    </div>
  )
}

Error.getInitialProps = async ({ res, err, asPath }) => {
  if (err) {
    Sentry.captureException(err)
  } else {
    Sentry.captureMessage(`Some error happened but missing data at path: ${asPath}`)
  }
  await Sentry.flush(2000)

  if (res) {
    // redirect to 404 page if there is any server side issues
    res.redirect('/404')
  }
  return {}
}

export default Error
